<template>
  <div>
    <div class="container-fluid">
      <div class="page-header">
        <Breadcrumbs main="articles" title="List" />
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="card" v-for="item in listData" :key="item.id">

            <TableList :id="item.id" :categories="item.categories" :currency="item.currency" :host="item.host">
            </TableList>

          </div>
        </div>
      </div>
    </div>
    <!-- Container-fluid Ends-->
  </div>
</template>
  
<script>
import { mapGetters } from "vuex";
import firebase from '@/utils/firestore-shim';
import TableList from "./lists/TableList.vue";
import Cookies from 'js-cookie';
export default {
  components: { TableList },
  data() {
    return {
      listData: []
    };
  },
  async mounted() {
    this.listData = await this.getStoresData();
  },
  methods: {
    async getStoresData() {
      let listData = [];
      var ProductRef = await firebase.firestore().collection("Sites")
        .where("host", "==", this.getStore())
        .get()
        .then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            listData.push(
              doc.data()
            );
          });
        });
      return listData;

    },
    getStore() {
      const host = Cookies.get('hostCookie');
      if (host) {
        return host;
      } else {
        this.$router.push('/dashboard/default');
      }
    },
  }
}
</script>
  
<style lang="scss" scoped>
table.text-center * {
  text-align: center;
}
</style>